<!-- Top header bar -->
<div class="header-bar">
    <span class="heading-title">Subtenants</span>
</div>

<!-- Current subtenant info -->
<div class="section">
    <span class="current-title">Current Subtenant:</span>
    <div *ngIf="(currentSubtenant | async) as s" class="current-subtenant-item">
        <div class="subtenant-item-row">
            <span class="row-label">Name:</span>
            <span class="row-value" id="slc-subtenant-current-name">{{s.name}}</span>
        </div>
        <br/>
        <div class="subtenant-item-row">
            <span class="row-label">Id:</span>
            <span class="row-value" id="slc-subtenant-current-id">{{s.id | fpReplace:'-':'.'}}</span>
        </div>
    </div>
</div>

<!-- Subtenant search -->
<div class="section">
    <div class="search-title-parent">
        <span class="current-title">Search By:&nbsp;&nbsp;</span>
        <p-select #dpdSearchBy (onChange)="duplex.send(inp.value)"
                    [options]="searchByOptions" [style]="{minWidth:'75px'}"></p-select>
    </div>
    <span class="input-icon-right search-parent">
        <!-- clear search icon -->
        <i (click)="onClickClear(inp)"
           [style.cursor]="'pointer'"
           [style.visibility]="showClearIcon ? 'visible' : 'hidden'"
           class="pi pi-times"></i>
        <!-- search input field -->
        <input #inp (input)="onSearchInput($event)" (keyup.enter)="onSearchInput($event)" class="search-input" id="slc-search-input" maxlength="100" pInputText
               tabindex="0"
               type="text"/>
    </span>
</div>

<!-- Search result section -->
<div class="section results-parent" tabindex="-1">
    <!-- Section heading for recent or results -->
    <span class="current-title">{{showingRecent ? 'Recent:' : 'Results:'}}</span>
    <br/>

    <!-- Subtenant list UI -->
    <div class="list-parent" tabindex="-1">

        <!-- Loader and empty message UI -->
        <div *ngIf="duplex.state !== 'content'" class="loader">
            <img *ngIf="duplex.state === 'loading'" alt="Loading" src="assets/images/ic_loader.gif"/>
            <span *ngIf="duplex.state === 'empty'">No data available</span>
        </div>

        <!-- Subtenants content -->
        <ng-container *ngIf="duplex.state === 'content'">

            <!-- Subtenant items  -->
            <ng-container *ngFor="let item of duplex.outVal; index as i;">
                <!-- Render item template -->
                <ng-container [ngTemplateOutletContext]="{$implicit:item,index:i}"
                              [ngTemplateOutlet]="tplSubtenantItem"></ng-container>
            </ng-container>

            <!-- Result overflow hint message -->
            <div *ngIf="!showingRecent && hasMoreResults" class="overflow-hint">
                <i class="pi pi-info-circle"></i>
                <span>&nbsp; More than 10 results found, please narrow down your search</span>
            </div>
        </ng-container>
    </div>
</div>

<!-- Subtenant item template -->
<ng-template #tplSubtenantItem let-i="i" let-item>
    <div (click)="onSelectSubtenant(item)" (keyup.enter)="onSelectSubtenant(item)"
         class="subtenant-item" tabindex="0">
        <div class="subtenant-item-row">
            <span class="row-label">Name:</span>
            <span class="row-value" id="slc-subtenant-list-{{i}}-name">{{item.name}}</span>
        </div>
        <br/>
        <div class="subtenant-item-row">
            <span class="row-label">Id:</span>
            <span class="row-value" id="slc-subtenant-list-{{i}}-id">{{item.id | fpReplace:'-':'.'}}</span>
        </div>
    </div>
</ng-template>
